import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";

export default function Header() {
  const history = useHistory();
  const [user, setUser] = useState({});

  const handleLogout = () => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      history.push("/login");
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      history.push("/login");
      // window.location = "/login";
    }

    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user")));
    }
  }, [history]);

  return (
    <>
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-lig ht">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link
              className="nav-link"
              data-widget="pushmenu"
              to="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </Link>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          {user.role === "admin" && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/users" className="nav-link">
               Web Users
              </Link>
            </li>
          )}
          {(user.role === "admin" ||
            user.role === "broker" ||
            user.role === "callcenter" ||
            user.role === "spectator") && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/forms/broker" className="nav-link">
                Broker
              </Link>
            </li>
          )}
          {(user.role === "admin" ||
            user.role === "medical" ||
            user.role === "callcenter" ||
            user.role === "spectator")  && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/forms/medical" className="nav-link">
                Medical
              </Link>
            </li>
          )}
          {(user.role === "admin" ||
            user.role === "general" ||
            user.role === "spectator") && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/forms/general" className="nav-link">
                General & App
              </Link>
            </li>
          )}
          {user.role === "admin" && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/users/app" className="nav-link">
               App Users
              </Link>
            </li>
          )}

          {user.role === "doctor" || user.email !== "jalalinicrh@gmail.com" && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/forms/xray" className="nav-link">
               All Xray Report
              </Link>
            </li>
          )}

          {(user.role === "admin" || user.role === "callcenter") && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/forms/visa" className="nav-link">
               Visa List
              </Link>
            </li>
          )}

          {(user.role === "admin" ||
            user.role === "medicaladmin") && (
            <li className="nav-item d-none d-sm-inline-block">
              <Link to="/forms/xray/new" className="nav-link">
              Medical Xray
              </Link>
            </li>
          )}
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          {/* Notifications Dropdown Menu */}
          <li className="nav-item dropdown">
            <Link className="nav-link" data-toggle="dropdown" to="#">
              <i className="far fa-user" /> {user.name}
            </Link>
            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right">
              <Link to="/users/profile" className="dropdown-item">
                <i className="fas fa-id-badge mr-2" /> Profile
              </Link>

              <div className="dropdown-divider" />
              <a href="/" className="dropdown-item" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt mr-1" /> Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}
    </>
  );
}
